import { COLOR_PALLETTE, COLOR_PALLETTE_DARK_MODE } from 'Globals/Constants'
import { CSSProperties, MutableRefObject } from 'react'
import styled from 'styled-components'
type Location = {
  location: string
  lat: number
  lng: number
  averageScore: number
}
export default ({
  resultTitleRef,
  userAnswersSent,
  closestLocations,
  mostDistantLocations,
  colorMode,
}: {
  resultTitleRef: MutableRefObject<HTMLDivElement | null>
  userAnswersSent: boolean
  closestLocations?: Location[]
  mostDistantLocations?: Location[]
  colorMode: 'light' | 'dark'
}) => {
  const currentColorPallette =
    colorMode === 'dark' ? COLOR_PALLETTE_DARK_MODE : COLOR_PALLETTE
  return (
    <ResultTitleWrapper
      ref={resultTitleRef}
      isActive={!!(userAnswersSent && closestLocations?.[0])}
    >
      Sie kommen zu{' '}
      <b>
        {Math.round((closestLocations?.[0]?.averageScore ?? 0) * 1000) / 10}%
      </b>{' '}
      aus{' '}
      <FoundLocation
        isActive={!!(userAnswersSent && closestLocations?.[0])}
        style={
          {
            color: currentColorPallette[2],
            '--order': 1,
          } as CSSProperties
        }
      >
        {closestLocations &&
          String(closestLocations.map((l) => l.location))
            .replaceAll(',', ', ')
            .replace(/,(?=[^,]+$)/, ' oder ')}
      </FoundLocation>{' '}
      <br />
      <span style={{ fontSize: '0.7em' }}>
        {' '}
        und sicher nicht aus{' '}
        <FoundLocation
          isActive={!!(userAnswersSent && closestLocations?.[0])}
          style={
            {
              color: currentColorPallette[0],
              '--order': 2,
              fontSize: '1em',
            } as CSSProperties
          }
        >
          {String(mostDistantLocations?.map((l) => l.location))
            .replaceAll(',', ', ')
            .replace(/,(?=[^,]+$)/, ' oder ')}
        </FoundLocation>
      </span>
    </ResultTitleWrapper>
  )
}
const ResultTitleWrapper = styled.div<{ isActive?: boolean }>`
  font-size: var(--small-text-size);
  line-height: 3rem;
  margin: 0 auto;
  max-width: 700px;
  margin-bottom: 2rem;
  padding-top: 2rem;
  text-align: center;
  line-height: 1.3;
  ${({ isActive }) => (isActive ? '' : 'display:none; opacity:0;')}
  transition: opacity 0.5s ease-in-out;
`
const FoundLocation = styled.span<{ isActive?: boolean }>`
  font-weight: 700;
  position: relative;
  font-size: 1.3em;
  line-height: 1;
  word-wrap: break-word;
  overflow-wrap: normal;
  transition: all 0.5s ease-in-out;
  background: linear-gradient(currentcolor, currentcolor) no-repeat 0 95%/0
    0.15em;
  ${({ isActive }) =>
    isActive &&
    'animation: underlineSlideIn 0.9s cubic-bezier(0.83, 0, 0.17, 1) forwards;'}
  animation-delay: calc(var(--order) * 0.4s);
  @keyframes underlineSlideIn {
    0% {
      background: linear-gradient(currentcolor, currentcolor) no-repeat 0 95%/0%
        0.15em;
    }
    100% {
      background: linear-gradient(currentcolor, currentcolor) no-repeat 0 95%/100%
        0.15em;
    }
  }
`
